
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { TYPES } from '../../config/inversify.types'

export default defineComponent({
  name: 'InputErrors',
  inject: {
    objectIdService: TYPES.ObjectIdService,
  },
  props: {
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-input-errors',
    }
  },
})
